export const dummyCarouselData = [
  {
    coverURL:
      "https://media.steelseriescdn.com/thumbs/filer_public/77/97/7797b056-28e4-4189-b3b3-28bbf4423914/march_deals_refresh_2025_homepage_carousel_d_v2.png__1920x900_crop-scale_optimize_subsampling-2.png",
    logoURL:
      "https://ik.imagekit.io/gmng/zones/steelseries/steelseries_logo.webp?updatedAt=1742902251881",
    alt: "SteelSeries",
    heading: "Spring Must-Haves at Must-See Prices!",
    desc: "Time to refresh, recharge, and respawn - grab pro-grade gear at unbeatable prices! Get up to 50% off!",
    links: [
      {
        text: "Check it out",
        url: "/zone/steelseries",
      },
      {
        text: "Go to Challenges",
        url: "/zone/steelseries/challenges",
      },
    ],
    theme: "steelseries",
  },
  {
    coverURL:
      "https://resource.logitechg.com/w_1800,h_1800,c_limit,q_auto,f_auto,dpr_1.0/d_transparent.gif/content/dam/gaming/en/homepage/hp-2/keep-playing-banner-desktop.jpg?v=1",
    logoURL:
      "https://ik.imagekit.io/gmng/zones/logitech-g/logitechg_logo.webp?updatedAt=1740743384345",
    alt: "Logitech G",
    heading: "Advanced Gear for Advanced Gaming",
    desc: "Gaming is our way of life. Through better gear and game integration, we facilitate an every day gaming experience.",
    links: [
      {
        text: "Check it out",
        url: "/zone/logitech-g",
      },
      {
        text: "Go to Challenges",
        url: "/zone/logitech-g/challenges",
      },
    ],
    theme: "logitech",
  },
];
